exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".order-slider-product[data-v-371e6220] {\n  width: 100%;\n}\n.product-image[data-v-371e6220] {\n  width: 100%;\n}\n.block-product-description[data-v-371e6220] {\n  line-height: 1.5em;\n  height: 3em;\n  overflow: hidden;\n}\n.product-weight[data-v-371e6220] {\n  font-size: 14px;\n  color: #828282;\n}\n.product-description[data-v-371e6220] {\n  font-size: 14px;\n  font-weight: 300;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.43;\n  letter-spacing: 0.09px;\n}\n", ""]);

// exports
